const PartsSpotlight = {
	init: function (options) {
		const container = options.container;
		if (!container) return;

		const triggers = container.querySelectorAll("[parts-spotlight]");
		const navs = container.querySelectorAll("[parts-spotlight-nav]");

		// Bind click handlers for dots on the image
		triggers.forEach((trigger) => {
			const target = trigger.getAttribute("parts-spotlight");
			if (!target) return;

			trigger.addEventListener("click", (e) => {
				this.show(e, target, container);
			});
		});

		// Bind click handlers for nav pills under the content
		navs.forEach((trigger) => {
			const target = trigger.getAttribute("parts-spotlight-nav");
			if (!target) return;

			trigger.addEventListener("click", (e) => {
				this.show(e, target, container);
			});
		});

		// Make sure the initial state is synced (first active dot / first dot)
		const initialHighlight =
			container.querySelector("[parts-spotlight].active") ||
			triggers[0];

		if (initialHighlight) {
			const initialTarget =
				initialHighlight.getAttribute("parts-spotlight");
			if (initialTarget) {
				this.show(null, initialTarget, container);
			}
		}
	},

	show: function (e, target, container) {
		// Active Highlight (dots on image)
		const currentHighlight = container.querySelector(
			"[parts-spotlight].active"
		);
		if (currentHighlight) {
			currentHighlight.classList.remove("active");
		}

		const newHighlight = container.querySelector(
			`[parts-spotlight="${target}"]`
		);
		if (newHighlight) {
			newHighlight.classList.add("active");
		}

		// Active Content (description text)
		const currentContent = container.querySelector(
			"[parts-spotlight-content].active"
		);
		if (currentContent) {
			currentContent.classList.remove("active");
		}

		const newContent = container.querySelector(
			`[parts-spotlight-content="${target}"]`
		);
		if (newContent) {
			newContent.classList.add("active");
		}

		// Active Nav (pills under content)
		const currentNav = container.querySelector(
			"[parts-spotlight-nav].active"
		);
		if (currentNav) {
			currentNav.classList.remove("active");
		}

		const newNav = container.querySelector(
			`[parts-spotlight-nav="${target}"]`
		);
		if (newNav) {
			newNav.classList.add("active");
		}

		// Image swap logic
		const mainImage = container.querySelector("[data-spotlight-image]");
		if (mainImage && newHighlight) {
			const originalSrc = mainImage.getAttribute("data-original-src");
			const altImage = newHighlight.getAttribute("data-alt-image");

			if (altImage) {
				mainImage.setAttribute("src", altImage);
			} else if (originalSrc) {
				// fallback to the base image
				mainImage.setAttribute("src", originalSrc);
			}
		}
	},
};

window.addEventListener("DOMContentLoaded", () => {
	const spotlights = document.querySelectorAll(".component-spotlight");

	spotlights.forEach((spotlightContainer) => {
		PartsSpotlight.init({
			container: spotlightContainer,
		});
	});
});
